import React, { useState } from "react";
// import PageTitle from "../../components/shared/PageTitle";
// import PageHeadline from "../../components/shared/PageHeadline";
import { useTranslation } from "react-i18next";
import bgContactUs from "../../assets/images/bg-contact-us.png";
import EffectSplatterWhite from "../../assets/images/effect-splatter-white.png";
// import axios from "axios";

export default function Index() {
    const { t } = useTranslation();
    const [isSuccess, setSuccess] = useState(false);
    const [isError, setError] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const MAIL_SENDER_URL = "https://bandoeng10k-mailer.vercel.app/api/email";
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        subject: "",
        message: "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        await fetch(
            MAIL_SENDER_URL,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
                mode: 'no-cors',
            },
        ).then((res) => {
            setFormData({
                name: "",
                email: "",
                phone: "",
                subject: "",
                message: "",
            });
            setSuccess(true);
            setTimeout(() => {
                setSuccess(false);
            }, 5000);
        })
            .catch(() => {
                setSuccess(false);
                setError(true);
            })
            .finally(() => {
                setLoading(false);
            });

        // await axios
        //     .post(MAIL_SENDER_URL, formData)
        //     .then((res) => {
        //         if (res.data.status === "success") {
        //             setFormData({
        //                 name: "",
        //                 email: "",
        //                 phone: "",
        //                 subject: "",
        //                 message: "",
        //             });
        //             setSuccess(true);
        //             setTimeout(() => {
        //                 setSuccess(false);
        //             }, 5000);
        //         } else {
        //             setError(true);
        //         }
        //     })
        //     .catch(() => {
        //         setSuccess(false);
        //         setError(true);
        //     })
        //     .finally(() => {
        //         setLoading(false);
        //     });
    };
    return (
        <div className="overflow-hidden md:px-0 px-4 bg-black relative">
            <img
                src={EffectSplatterWhite}
                alt="Decorative splatter effect"
                className="pointer-events-none absolute top-64 md:top-48 left-96 z-[1] object-contain opacity-80 select-none"
            />
            <img
                src={bgContactUs}
                alt=""
                className="pointer-events-none absolute bottom-0 right-0 z-[10] object-contain object-right-bottom select-none w-auto max-w-[min(92vw,520px)] md:max-w-none h-[clamp(220px,50vh,720px)] md:h-[720px]"
            />
            {/* <div className="relative">
                <PageTitle title={t("contact.title")} />
            </div> */}
            {/* <div className="relative min-h-[240px] lg:min-h-[300px] bg-bgBannerPage bg-contain md:bg-cover bg-no-repeat top-[86px] md:top-[109px] 2xl:top-[136px] flex justify-center items-center">
                <PageHeadline title={t("contact.title")} />
            </div> */}
            <div className="top-24 md:top-40 relative md:px-16 lg:px-24 xl:px-28 2xl:px-36 px-0 py-5 pb-96 z-50">
                <div className="basis-full py-8 max-md:max-w-[200px] max-md:text-wrap flex gap-x-4">
                    <span className="font-wantCoffee text-5xl md:text-8xl text-white">{t("contact.title")}</span>
                    <span className="font-wantCoffee text-5xl md:text-8xl text-primary">{t("contact.subTitle")}</span>
                </div>
                <div className="bg-[#e4e4e4] min-h-fit container px-8 py-6 rounded-3xl w-full md:w-1/2 font-poppins text-brandBlue">
                    {isSuccess && (
                        <div className="w-full bg-sky-200 p-4 mb-10 text-sky-800 rounded-lg">
                            <h1>
                                {t("contact.successMessage")}
                            </h1>
                        </div>
                    )}

                    {isError && (
                        <div className="w-full bg-red-200 p-4 mb-10 text-red-800 rounded-lg">
                            <h1>{t("contact.failedMessage")}</h1>
                        </div>
                    )}
                    <div className="flex items-center justify-start h-full font-roboto">
                        <form className="w-full space-y-8" onSubmit={handleSubmit}>
                            {/* <div className="space-y-6">
                                <label htmlFor="subject" className="!font-poppins">{t("contact.subject")}</label>
                                <input
                                    id="subject"
                                    name="subject"
                                    type="text"
                                    value={formData.subject}
                                    onChange={handleChange}
                                    className="bg-brandLightGrey block border w-fit 2xl:py-6 2xl:px-6 p-4 rounded-lg placeholder:text-neutral-400 text-brandBlue"
                                    placeholder={t("contact.subject")}
                                    required
                                />
                            </div> */}
                            <div className="space-y-2">
                                <label htmlFor="name" className="!font-roboto font-semibold">{t("contact.name")}</label>
                                <input
                                    id="name"
                                    name="name"
                                    type="text"
                                    value={formData.name}
                                    onChange={handleChange}
                                    className="bg-brandLightGrey block border w-full 2xl:py-6 2xl:px-6 p-4 rounded-lg placeholder:text-neutral-400 text-brandBlue"
                                    placeholder={t("contact.name")}
                                    required
                                />
                            </div>
                            <div className="flex max-md:flex-wrap md:inline-flex w-full max-md:space-y-6 md:space-x-10">
                                <div className="w-full space-y-2">
                                    <label htmlFor="email" className="!font-roboto font-semibold">{t("contact.email")}</label>
                                    <input
                                        id="email"
                                        name="email"
                                        type="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        className="bg-brandLightGrey block border w-full 2xl:py-6 2xl:px-6 p-4 rounded-lg placeholder:text-neutral-400 text-brandBlue"
                                        placeholder="email@mail.com"
                                        required
                                    />
                                </div>
                            </div>
                            <div className="flex max-md:flex-wrap md:inline-flex w-full max-md:space-y-6 md:space-x-10">
                                <div className="w-full space-y-2">
                                    <label htmlFor="phone" className="!font-roboto font-semibold">{t("contact.phone")}</label>
                                    <input
                                        id="phone"
                                        name="phone"
                                        type="number"
                                        value={formData.phone}
                                        onChange={handleChange}
                                        className="bg-brandLightGrey block border w-full 2xl:py-6 2xl:px-6 p-4 rounded-lg placeholder:text-neutral-400 text-brandBlue"
                                        placeholder="628512345678"
                                        required
                                    />
                                </div>
                            </div>
                            <div className="space-y-2">
                                <label htmlFor="message" className="!font-roboto font-semibold">{t("contact.message")}</label>
                                <textarea
                                    rows={6}
                                    id="message"
                                    name="message"
                                    value={formData.message}
                                    onChange={handleChange}
                                    className="bg-brandLightGrey block border w-full 2xl:py-6 2xl:px-6 p-4 rounded-lg placeholder:text-neutral-400 text-brandBlack"
                                    placeholder={t("contact.messagePlaceholder")}
                                    required
                                ></textarea>
                            </div>
                            <div className="flex flex-wrap flex-row md:flex-col gap-4 md:gap-0">
                                <button
                                    type="submit"
                                    disabled={isLoading}
                                    className="w-full md:w-fit px-4 bg-primary text-white py-2 rounded-lg shadow-2xl uppercase font-bold md:ml-auto"
                                >
                                    {t("contact.send")}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}
